































































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const getUrl = require('baimahu/url-with-param');
const API = {
  list: `${FCAPI}/shang/setting/account/profile`,
  delete: `${FCAPI}/shang/setting/account/profile/`,
  add: `${FCAPI}/shang/setting/account/profile`,
};
function initAccountData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
@Component
export default class AccountSetting extends Vue {
  account_data: any = initAccountData();
  is_loading: boolean = false;
  name: string = '';
  is_show_add_modal: boolean = false;
  validate_map: any = {
    name: {
      value: '',
      status: '',
      help: '',
    },
    mobile: {
      value: '',
      status: '',
      help: '',
    },
  };
  paginationOption(data: any) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.limit}条`,
      pageSize: data.limit,
      current: data.current,
    };
  }

  editAccount(item: any) {
    console.log(item);
    this.$router.push(`/setting/edit-account?id=${item.id}&name=${item.name}`);
  }

  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getAccountData(data.current, {
      name: this.name,
    });
  }

  clearFilterValue() {
    this.name = '';
  }

  // 格式化账号id
  formarAccountId(id: any) {
    const str = '00';
    if (+id < 100) {
      return (str + id).slice(-3);
    }
    return id;
  }

  // 关闭新增账号模态窗
  closeModal() {
    this.validate_map = {
      name: {
        value: '',
        status: '',
        help: '',
      },
      mobile: {
        value: '',
        status: '',
        help: '',
      },
    };
    this.is_show_add_modal = false;
  }

  // 点击添加新增账号模态窗确定按钮
  @changeLoading(['is_loading'])
  async confirmAddAccount() {
    let is_valid = true;
    if (!this.validate_map.name.value) {
      this.validate_map.name.status = 'error';
      this.validate_map.name.help = '请输入姓名';
      is_valid = false;
    } else {
      this.validate_map.name.status = '';
      this.validate_map.name.help = '';
      is_valid = true;
    }
    if (!this.validate_map.mobile.value) {
      this.validate_map.mobile.status = 'error';
      this.validate_map.mobile.help = '请输入手机号';
      is_valid = false;
    } else {
      if (this.validate_map.mobile.value.length !== 11) {
        this.validate_map.mobile.status = 'error';
        this.validate_map.mobile.help = '手机号格式错误';
        is_valid = false;
      } else {
        this.validate_map.mobile.status = '';
        this.validate_map.mobile.help = '';
        is_valid = true;
      }
    }
    if (!is_valid) {
      return;
    }
    const res = await this.$axios.post(API.add, {
      name: this.validate_map.name.value,
      mobile: this.validate_map.mobile.value,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.closeModal();
    await this.getAccountData();
    this.$message.success('添加账号成功');
  }

  // 删除账号
  @changeLoading(['is_loading'])
  async deleteAccount(item: any) {
    this.$confirm({
      icon: 'null',
      title: `确定删除qq账号？`,
      content: '删除后，该账号将不能登录系统',
      class: 'delete-modal',
      onOk: async () => {
        const res = await this.$axios.delete(`${API.delete}${item.id}`);
        if (res.data.status !== 200) {
          this.$message.error(res.data.message);
          return;
        }
        this.$message.success('删除成功');
        await this.getAccountData();
      },
    });
  }

  // 添加账号
  addAccount() {
    this.is_show_add_modal = true;
  }

  // 搜索按钮
  @changeLoading(['is_loading'])
  async search() {
    await this.getAccountData(1, {
      name: this.name,
    });
  }

  // 获取账号列表
  @changeLoading(['is_loading'])
  async getAccountData(current: number = 1, query_params?: any) {
    const url = getUrl(API.list, {
      limit: 20,
      current,
      ...query_params,
    });
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.account_data = initAccountData(res.data.data);
  }
  async created() {
    await this.getAccountData();
  }
}
